module.exports = __webpack_public_path__ + "public-ui/fonts/symbols.e8730678.woff2";